<template>
  <div>
    <div class="columns is-multiline is-mobile">
      <div class="column is-full">
        <window title="Vue Spinner Component <a href='https://github.com/sergeyloysha/vue-spinner-component'
                                                target='_blank'>(more info)</a>">
          <div class="app__preview app__side">
            <div class="columns is-mobile is-multiline">
              <div class="column-tablet is-full-mobile">
                <spinner :status="spinner.status" :color="spinner.color" :size="spinner.size"
                 :depth="spinner.depth" :rotation="spinner.rotation" :speed="spinner.speed"
                ></spinner>
              </div>
              <div class="column is-half-tablet is-full-mobile">
                <div class="field">
                  <label class="label">Size</label>
                  <div class="control">
                    <vue-slider ref="slider" :min="30" :max="150" v-model="spinner.size">
                    </vue-slider>
                  </div>
                </div>

                <div class="field">
                  <label class="label">Depth</label>
                  <div class="control">
                    <vue-slider ref="slider" :min="1" :max="10" v-model="spinner.depth">
                    </vue-slider>
                  </div>
                </div>

                <div class="field">
                  <label class="label">Color</label>
                  <div class="control">
                    <el-color-picker v-model="spinner.color"></el-color-picker>
                  </div>
                </div>

                <div class="field">
                  <label class="label">Rotation</label>
                  <div class="control">
                    <b-switch
                      v-model="spinner.rotation" @click="spinner.rotation = !spinner.rotation"
                    >{{ rotationMessage }}</b-switch>
                  </div>
                </div>

                <div class="field">
                  <label class="label">Speed</label>
                  <div class="control">
                    <vue-slider
                      ref="slider" :min="0.5" :max="2" :interval="0.01" v-model="spinner.speed"
                    ></vue-slider>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </window>
      </div>
      <div class="column is-full">
        <window title="Vue-spinner (<a href='https://github.com/greyby/vue-spinner' target='_blank'>more info</a>)">
          <div class="columns vspin is-multiline is-mobile">
            <div class="column">
              <pulse-loader :loading="loading" :color="spinner.color"></pulse-loader>
            </div>
            <div class="column">
              <grid-loader :loading="loading" :color="spinner.color"></grid-loader>
            </div>
            <div class="column">
              <clip-loader :loading="loading" :color="spinner.color"></clip-loader>
            </div>
            <div class="column">
              <rise-loader :loading="loading" :color="spinner.color"></rise-loader>
            </div>
          </div>
          <div class="columns vspin is-multiline is-mobile">
            <div class="column">
              <beat-loader :loading="loading" :color="spinner.color"></beat-loader>
            </div>
            <div class="column">
              <sync-loader :loading="loading" :color="spinner.color"></sync-loader>
            </div>
            <div class="column">
              <rotate-loader :loading="loading" :color="spinner.color"></rotate-loader>
            </div>
            <div class="column">
              <fade-loader :loading="loading" :color="spinner.color"></fade-loader>
            </div>
          </div>
          <div class="columns vspin is-multiline is-mobile">
            <div class="column">
              <pacman-loader :loading="loading" :color="spinner.color"></pacman-loader>
            </div>
            <div class="column">
              <square-loader :loading="loading" :color="spinner.color"></square-loader>
            </div>
            <div class="column">
              <scale-loader :loading="loading" :color="spinner.color"></scale-loader>
            </div>
            <div class="column">
              <skew-loader :loading="loading" :color="spinner.color"></skew-loader>
            </div>
          </div>
          <div class="columns vspin is-multiline is-mobile">
            <div class="column">
              <moon-loader :loading="loading" :color="spinner.color"></moon-loader>
            </div>
            <div class="column">
              <ring-loader :loading="loading" :color="spinner.color"></ring-loader>
            </div>
            <div class="column">
              <bounce-loader :loading="loading" :color="spinner.color"></bounce-loader>
            </div>
            <div class="column">
              <dot-loader :loading="loading" :color="spinner.color"></dot-loader>
            </div>
          </div>
        </window>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from 'vue-spinner-component/src/Spinner.vue';
import VueSlider from 'vue-slider-component';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import GridLoader from 'vue-spinner/src/GridLoader.vue';
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import RiseLoader from 'vue-spinner/src/RiseLoader.vue';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';
import SyncLoader from 'vue-spinner/src/SyncLoader.vue';
import RotateLoader from 'vue-spinner/src/RotateLoader.vue';
import FadeLoader from 'vue-spinner/src/FadeLoader.vue';
import PacmanLoader from 'vue-spinner/src/PacmanLoader.vue';
import SquareLoader from 'vue-spinner/src/SquareLoader.vue';
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue';
import SkewLoader from 'vue-spinner/src/SkewLoader.vue';
import MoonLoader from 'vue-spinner/src/MoonLoader.vue';
import RingLoader from 'vue-spinner/src/RingLoader.vue';
import BounceLoader from 'vue-spinner/src/BounceLoader.vue';
import DotLoader from 'vue-spinner/src/DotLoader.vue';

export default {
  data() {
    return {
      loading: true,
      spinner: {
        size: 150,
        status: true,
        color: '#4fc08d',
        depth: 3,
        rotation: true,
        speed: 0.8,
      },
    };
  },
  components: {
    Spinner,
    VueSlider,
    PulseLoader,
    GridLoader,
    ClipLoader,
    RiseLoader,
    BeatLoader,
    SyncLoader,
    RotateLoader,
    FadeLoader,
    PacmanLoader,
    SquareLoader,
    ScaleLoader,
    SkewLoader,
    MoonLoader,
    RingLoader,
    BounceLoader,
    DotLoader,
  },
  computed: {
    statusMessage() {
      return this.spinner.status ? 'Active' : 'Inactive';
    },
    rotationMessage() {
      return this.spinner.rotation ? 'Forward' : 'Backward';
    },
  },
};
</script>

<style lang="scss" scoped>
.columns {
  justify-content: space-evenly;
  align-items: center;
  &.vspin {
    .column {
      text-align: center;
      margin-bottom: 20px;
    }
  }
  .v-spinner {
    display: inline-flex;
    margin: auto;
  }
}
</style>
